var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "login-container"
  }, [_vm._m(0), _c("el-form", {
    ref: "loginForm",
    staticClass: "login-form",
    attrs: {
      model: _vm.loginForm,
      rules: _vm.loginRules,
      autocomplete: "on",
      "label-position": "left"
    }
  }, [_c("div", {
    staticClass: "title-container"
  }, [_c("h2", {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("login.title")) + " ")])]), _c("el-form-item", {
    attrs: {
      prop: "mobileNumber"
    }
  }, [_c("span", {
    staticClass: "svg-container"
  }, [_c("svg-icon", {
    attrs: {
      name: "mobile"
    }
  })], 1), _c("el-input", {
    ref: "mobileNumber",
    attrs: {
      placeholder: _vm.$t("login.mobile"),
      name: "mobileNumber",
      type: "text",
      autocomplete: "on"
    },
    model: {
      value: _vm.loginForm.mobileNumber,
      callback: function ($$v) {
        _vm.$set(_vm.loginForm, "mobileNumber", $$v);
      },
      expression: "loginForm.mobileNumber"
    }
  })], 1), _c("el-button", {
    staticStyle: {
      width: "40%",
      "margin-left": "150px",
      "margin-bottom": "30px"
    },
    attrs: {
      loading: _vm.loading,
      type: "primary"
    },
    nativeOn: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.requestOtp.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("login.requestOtp")) + " ")])], 1)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "logo"
  }, [_c("img", {
    staticClass: "login-logo",
    attrs: {
      src: "/img/osum-logo-white.png"
    }
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };